module.exports = __webpack_public_path__ + "static/img/box.5e81441e.png";